import { User } from './user'
import { Worker } from './worker'
import { ContinuingEducationCourse } from './continuingEducationCourse'
import { FeathersModel } from './feathersModel'
import { DateUtils } from '../services/date-utils.service'
import { createIntlComparer, DEFAULT_LOCALES } from '../services/utils'

export class Assistant extends FeathersModel {
  static serviceName = 'assistants'
  static intlSortComparer = createIntlComparer(DEFAULT_LOCALES, {
    sensitivity: 'accent',
  })

  workerId: string
  worker: Worker

  coordinatorNote: string
  isDeactivated: boolean
  deactivatedAt: Date
  deactivationReason: string

  isAdvanced: boolean

  supervisionHours: number
  isStrong: boolean

  keyCoordinatorId: number
  keyCoordinator: User

  hasHbvVaccine: boolean = false

  get title(): string {
    return this.worker.user.title
  }

  get birthDate(): string | Date {
    return this.worker.user.birthDate
  }

  get genderId(): number {
    return this.worker.user.genderId
  }

  get idCardNumber(): string {
    return this.worker.user.idCardNumber
  }

  get nationalityId(): number {
    return this.worker.user.nationalityId
  }

  get address_street(): string {
    return this.worker.user.address_street
  }

  get address_houseNumber(): string {
    return this.worker.user.address_houseNumber
  }

  get address_city(): string {
    return this.worker.user.address_city
  }

  get address_postcode(): string {
    return this.worker.user.address_postcode
  }

  get educationalAttainmentId(): number {
    return this.worker.user.educationalAttainmentId
  }

  get firstName(): string {
    return this.worker.user.firstName
  }

  get lastName(): string {
    return this.worker.user.lastName
  }

  get hasTrainingAsWorkerInSocialServices(): boolean {
    return this.worker.hasTrainingAsWorkerInSocialServices
  }

  get hasTrainingAsSocialWorker(): boolean {
    return this.worker.hasTrainingAsSocialWorker
  }

  set title(title: string) {
    this.worker.user.title = title
  }

  set birthDate(birthDate: string | Date) {
    this.worker.user.birthDate = birthDate
  }

  set genderId(genderId: number) {
    this.worker.user.genderId = genderId
  }

  set idCardNumber(idCardNumber: string) {
    this.worker.user.idCardNumber = idCardNumber
  }

  set nationalityId(nationalityId: number) {
    this.worker.user.nationalityId = nationalityId
  }

  set address_street(address_street: string) {
    this.worker.user.address_street = address_street
  }

  set address_houseNumber(address_houseNumber: string) {
    this.worker.user.address_houseNumber = address_houseNumber
  }

  set address_city(address_city: string) {
    this.worker.user.address_city = address_city
  }

  set address_postcode(address_postcode: string) {
    this.worker.user.address_postcode = address_postcode
  }

  set educationalAttainmentId(educationalAttainmentId: number) {
    this.worker.user.educationalAttainmentId = educationalAttainmentId
  }

  set firstName(firstName: string) {
    this.worker.user.firstName = firstName
  }

  set lastName(lastName: string) {
    this.worker.user.lastName = lastName
  }

  set hasTrainingAsWorkerInSocialServices(hasTrainingAsWorkerInSocialServices: boolean) {
    this.worker.hasTrainingAsWorkerInSocialServices = hasTrainingAsWorkerInSocialServices
  }

  set hasTrainingAsSocialWorker(hasTrainingAsSocialWorker: boolean) {
    this.worker.hasTrainingAsSocialWorker = hasTrainingAsSocialWorker
  }

  get fullname(): string {
    return this.worker.user.fullName()
  }

  turnSubresourcesIntoFrontendModels() {
    this.worker = this.worker ? Worker.createFromProps(Worker, this.worker) : this.worker
    this.keyCoordinator = this.keyCoordinator ? User.createFromProps(User, this.keyCoordinator) : this.keyCoordinator
    if (this.worker?.continuingEducationCourses) {
      for (let i = 0; i < this.worker.continuingEducationCourses.length; i++) {
        this.worker.continuingEducationCourses[i] = ContinuingEducationCourse.createFromProps(
          ContinuingEducationCourse,
          this.worker.continuingEducationCourses[i],
        )
      }
    }
  }

  removeContinuingEducationCourse(id) {
    this.worker.continuingEducationCourses = this.worker.continuingEducationCourses.filter(
      (c: ContinuingEducationCourse) => c.id !== id,
    )
  }

  static sortByName(a: Assistant, b: Assistant) {
    return Assistant.intlSortComparer(a.worker.user.fullName(), b.worker.user.fullName())
  }

  isInactive() {
    return DateUtils.canBeParsedToDate(this.deactivatedAt)
  }

  // get isDeactivated() {
  //   return DateUtils.canBeParsedToDate(this.deactivatedAt)
  // }
  //
  // set isDeactivated(value) {
  //   return
  // }
}
